import { AlertCircle, Clock, UserCheck } from "lucide-react";

export const getStatusIcon = (status: string) => {
  switch (status) {
    case "active":
      return <UserCheck className="w-4 h-4 text-green-500" />;
    case "pending":
      return <Clock className="w-4 h-4 text-yellow-500" />;
    case "expired":
      return <AlertCircle className="w-4 h-4 text-red-500" />;
    default:
      return null;
  }
};
